import { PAGEBUILDER_SET_PAGEID } from './../configReducer/actions';
const pageIdReducer = (
  state: string = '',
  action: {
    payload: string;
    type: string;
  }
) => {
  switch (action.type) {
    case PAGEBUILDER_SET_PAGEID:
      return action.payload;
    default:
      return state;
  }
};

export { pageIdReducer };
